var map = {
	"./African.png": 378,
	"./All.png": 379,
	"./Bibimbap.svg": 380,
	"./Chinese .png": 381,
	"./Japanese.png": 382,
	"./Mexican.png": 383,
	"./Pastry.png": 384,
	"./Samosa.svg": 385,
	"./Thai.png": 386,
	"./b1.jpg": 93,
	"./b2.jpg": 94,
	"./b3.jpg": 95,
	"./b4.jpg": 96,
	"./b5.jpg": 97,
	"./baking.png": 387,
	"./birthday-cake.png": 388,
	"./bread.png": 389,
	"./breakfast.png": 390,
	"./bw_logos/African.png": 192,
	"./bw_logos/All.png": 193,
	"./bw_logos/Bakers.png": 194,
	"./bw_logos/Bread.png": 195,
	"./bw_logos/Chinese .png": 196,
	"./bw_logos/Cookie.png": 197,
	"./bw_logos/Drinks.png": 198,
	"./bw_logos/Japanese.png": 199,
	"./bw_logos/Mexican.png": 200,
	"./bw_logos/Near Me.png": 201,
	"./bw_logos/Pastry.png": 202,
	"./bw_logos/Price.png": 203,
	"./bw_logos/Rice and Egg.png": 204,
	"./bw_logos/Thai.png": 205,
	"./bw_logos/carrot.svg": 206,
	"./bw_logos/chef.png": 207,
	"./bw_logos/cooking.png": 208,
	"./bw_logos/curry.png": 209,
	"./bw_logos/immediate.png": 210,
	"./bw_logos/indian.png": 211,
	"./bw_logos/italian .png": 212,
	"./bw_logos/now.svg": 213,
	"./bw_logos/price.svg": 214,
	"./cake.png": 391,
	"./colour icons.textClipping": 392,
	"./cookie.png": 393,
	"./cookies.png": 394,
	"./curry.png": 395,
	"./dairy.png": 396,
	"./donut.png": 397,
	"./dosa.png": 398,
	"./drink.png": 399,
	"./fried.png": 400,
	"./hat.png": 401,
	"./hummus.png": 402,
	"./indian.png": 403,
	"./instant-noodles.png": 404,
	"./italian.png": 405,
	"./macaroons.png": 406,
	"./paella.png": 407,
	"./pie.png": 408,
	"./pig.svg": 409,
	"./ranbir.jpg": 410,
	"./sauces.png": 411,
	"./seafood.png": 412,
	"./sushi.png": 413,
	"./vegetable.png": 414,
	"./wonton-noodles.png": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;